function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import { Editor } from '@tiptap/react';
import { BubbleMenuOverflowActions, LINE_FORMAT_SECTION_ITEMS, OVERFLOW_ACTION_SECTION, OverflowType, TipTapFormats } from 'common/components/tiptap-editor/constants';
import { generateShortcutLabel, getCommandKey, KeyModifiers } from 'common/util/keyboard';
import { isURL } from 'common/util/url';
import { TrackingEvent } from 'common/report/dashboards/tracking';
import { ButtonReact } from '../button';
import { ButtonTheme } from '../button/constants';
import { DropMenuReact } from '../drop-menu';
import { InputReact } from '../input';
import { ValidationStatus } from '../input/types';
import { SectionItem } from '../items-menu/types';
import { SelectReact } from '../select';
import { SelectTheme } from '../select/constants';
import { SvgIconReact } from '../svg-icon';
import { Visibility, VisibilityChangeEvent } from '../base/stackable';
import styles from './bubble-menu.module.styl';
const COMMAND_KEY = getCommandKey();
export const BubbleMenuContent = (_ref: {
  editor: Editor;
  onEnableDragging?: () => void;
  onDisableDragging?: () => void;
  onTrack: (event: TrackingEvent, properties: Record<string, unknown>) => void;
}) => {
  var _textFormattingItems$;
  let {
    onTrack,
    editor
  }: {
    editor: Editor;
    onEnableDragging?: () => void;
    onDisableDragging?: () => void;
    onTrack: (event: TrackingEvent, properties: Record<string, unknown>) => void;
  } = _ref;
  if (!editor) return null;
  const [isBubbleMenuOverflowOpen, setIsBubbleMenuOverflowOpen] = React.useState(false);
  const [isBubbleMenuLineFormatterOpen, setIsBubbleMenuLineFormatterOpen] = React.useState(false);
  const [isBubbleMenuLinkInputOpen, setIsBubbleMenuLinkInputOpen] = React.useState(false);
  const [{
    linkInputHref,
    urlInputInvalidMessage
  }, setLinkInput] = React.useState({
    linkInputHref: "",
    urlInputInvalidMessage: ""
  });
  const textFormattingItems: SectionItem[] = LINE_FORMAT_SECTION_ITEMS.map(item => _objectSpread(_objectSpread({}, item), {}, {
    isSelected: item.isSelected(editor),
    onSelect: selected => {
      // close the menu
      selected.onClick(editor);
      setIsBubbleMenuLineFormatterOpen(false);
      editor.commands.selectAll();
      editor.commands.setTextSelection(0);
      onTrack(TrackingEvent.FormatTextCard, {
        type: item.value,
        'overflow type': OverflowType.Text,
        'is active': item.isSelected
      });
    }
  }));
  return <div elref='bubbleMenu' className={styles.bubbleMenu} data-sentry-component="BubbleMenuContent" data-sentry-source-file="bubble-menu.tsx">
      <div className={styles.bubbleMenuSection}>
        <SelectReact alwaysShowCaret disableFocus={false} disableSearch elref={"headingSelect"} icon={{
        leftIcon: (_textFormattingItems$ = textFormattingItems.find(item => item.isSelected)) === null || _textFormattingItems$ === void 0 ? void 0 : _textFormattingItems$.icon
      }} iconOnly menuHeight={500} menuWidth={150} open={isBubbleMenuLineFormatterOpen} sections={[{
        items: textFormattingItems
      }]} showIconOnlyDownCaret theme={SelectTheme.Tertiary} onMenuChange={ev => {
        setIsBubbleMenuLineFormatterOpen(ev.detail.isOpen);
      }} data-sentry-element="SelectReact" data-sentry-source-file="bubble-menu.tsx" />
        <ButtonReact elref={"bulletListButton"} icon={"type-list"} pressed={editor.isActive(TipTapFormats.BulletList)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Bulleted list ".concat(generateShortcutLabel("4", {
          forMarkdown: true,
          modifiers: [COMMAND_KEY, KeyModifiers.Alt]
        }))
      }} onClick={() => {
        editor.chain().focus().toggleBulletList().run();
        onTrack(TrackingEvent.FormatTextCard, {
          type: TipTapFormats.BulletList,
          'is active': editor.isActive(TipTapFormats.BulletList)
        });
      }} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
      </div>
      <div className={styles.bubbleMenuSection}>
        <ButtonReact elref={"boldButton"} icon={"bold"} pressed={editor.isActive(TipTapFormats.Bold)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Bold text ".concat(generateShortcutLabel("B", {
          forMarkdown: true,
          modifiers: [COMMAND_KEY]
        }))
      }} onClick={() => {
        editor.chain().focus().toggleBold().run();
        onTrack(TrackingEvent.FormatTextCard, {
          type: TipTapFormats.Bold,
          'is active': editor.isActive(TipTapFormats.Bold)
        });
      }} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
        <ButtonReact elref={"italicButton"} icon={"italic"} pressed={editor.isActive(TipTapFormats.Italic)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Italic text ".concat(generateShortcutLabel("I", {
          forMarkdown: true,
          modifiers: [COMMAND_KEY]
        }))
      }} onClick={() => {
        editor.chain().focus().toggleItalic().run();
        onTrack(TrackingEvent.FormatTextCard, {
          type: TipTapFormats.Italic,
          'is active': editor.isActive(TipTapFormats.Italic)
        });
      }} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
        <ButtonReact elref={"strikethroughButton"} icon={"strikethrough"} pressed={editor.isActive(TipTapFormats.StrikeThrough)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Strikethrough ".concat(generateShortcutLabel("S", {
          forMarkdown: true,
          modifiers: [COMMAND_KEY, KeyModifiers.Shift]
        }))
      }} onClick={() => {
        editor.chain().focus().toggleStrike().run();
        onTrack(TrackingEvent.FormatTextCard, {
          type: TipTapFormats.StrikeThrough,
          'is active': editor.isActive(TipTapFormats.StrikeThrough)
        });
      }} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
      </div>
      <div className={styles.bubbleMenuSection}>
        <ButtonReact elref={"highlightButton"} icon={"text-highlight"} pressed={editor.isActive(TipTapFormats.Highlight)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Highlight ".concat(generateShortcutLabel("H", {
          forMarkdown: true,
          modifiers: [COMMAND_KEY, KeyModifiers.Shift]
        }))
      }} onClick={() => {
        editor.chain().focus().toggleHighlight().run();
        onTrack(TrackingEvent.FormatTextCard, {
          type: TipTapFormats.Highlight,
          'is active': editor.isActive(TipTapFormats.Highlight)
        });
      }} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
        <ButtonReact elref={"linkButton"} icon={"link"} pressed={editor.isActive(TipTapFormats.Link)} theme={ButtonTheme.Tertiary} tooltip={{
        text: "Link"
      }} onClick={() => setIsBubbleMenuLinkInputOpen(true)} data-sentry-element="ButtonReact" data-sentry-source-file="bubble-menu.tsx" />
        {isBubbleMenuLinkInputOpen && <DropMenuReact open onChange={ev => {
        const evt = ev as unknown as VisibilityChangeEvent;
        if (!evt.detail) {
          return;
        }
        const isOpen = evt.detail.state === Visibility.Open;
        setIsBubbleMenuLinkInputOpen(isOpen);
      }}>
            <div className={styles.linkInputPane} elref='linkInputPane'>
              <InputReact className={styles.linkInput} elref={"linkInput"} errorMessage={urlInputInvalidMessage} placeholder={"https://mixpanel.com/"} validationStatus={urlInputInvalidMessage ? ValidationStatus.Invalid : ValidationStatus.Default} onInput={ev => {
            const {
              value
            }: {
              value: string;
            } = ev.target;
            let invalidMessage = "";
            if (!isURL(value)) {
              invalidMessage = "Please input a valid URL";
            } else if (!(value.startsWith("http") || value.startsWith("https"))) {
              invalidMessage = "URL must start with either \"http\" or \"https\"";
            }
            setLinkInput({
              linkInputHref: value,
              urlInputInvalidMessage: invalidMessage
            });
          }} value={editor.isActive(TipTapFormats.Link) ? editor.getAttributes(TipTapFormats.Link).href : linkInputHref} />
              {editor.isActive(TipTapFormats.Link) && <ButtonReact className={styles.linkButton} elref={"linkRemovalButton"} theme={ButtonTheme.Secondary} onClick={() => {
            editor.chain().focus().unsetLink().run();
            onTrack(TrackingEvent.FormatTextCard, {
              type: TipTapFormats.Link,
              'is active': false
            });
            setIsBubbleMenuLinkInputOpen(false);
          }}>
                  Remove Link
                </ButtonReact>}
              <ButtonReact className={styles.linkButton} disabled={Boolean(!editor.isActive(TipTapFormats.Link) && !linkInputHref || urlInputInvalidMessage)} elref={"linkSetButton"} theme={ButtonTheme.Primary} onClick={() => {
            // only set the link if the user inputted a new link, so in the case where there's already a link there
            // and the user clicked on link, we want to keep the existing link
            if (!(!linkInputHref && editor.isActive(TipTapFormats.Link))) {
              editor.chain().extendMarkRange(TipTapFormats.Link).setLink({
                href: linkInputHref
              }).run();
            }
            setIsBubbleMenuLinkInputOpen(false);
            setLinkInput({
              linkInputHref: "",
              urlInputInvalidMessage: ""
            });
            onTrack(TrackingEvent.FormatTextCard, {
              type: TipTapFormats.Link,
              'is active': true
            });
          }}>
                <SvgIconReact icon={"link"} /> Link
              </ButtonReact>
            </div>
          </DropMenuReact>}
      </div>
      <div className={styles.bubbleMenuSection}>
        <SelectReact disableFocus={false} disableSearch elref={"overflowSelect"} icon={{
        leftIcon: "ellipsis"
      }} iconOnly menuHeight={500} menuWidth={150} open={isBubbleMenuOverflowOpen} sections={OVERFLOW_ACTION_SECTION.map(section => ({
        items: section.map(item => _objectSpread(_objectSpread({}, item), {}, {
          isDisabled: item.isDisabled(editor),
          isSelected: !item.isDisabled(editor) && item.isSelected(editor),
          onSelect: selected => {
            setIsBubbleMenuOverflowOpen(false);
            item.onClick(editor);
            onTrack(TrackingEvent.FormatTextCard, {
              type: selected.value,
              'overflow type': OverflowType.Other,
              'is active': selected.value === BubbleMenuOverflowActions.Divider || editor.isActive(selected.value)
            });
          }
        }))
      }))} theme={SelectTheme.Tertiary} onMenuChange={ev => setIsBubbleMenuOverflowOpen(ev.detail.isOpen)} data-sentry-element="SelectReact" data-sentry-source-file="bubble-menu.tsx" />
      </div>
    </div>;
};